var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9441 0.931152C19.6045 0.931152 25 6.33953 25 13C25 19.6733 19.6045 25.0689 12.9441 25.0689C6.27072 25.0689 0.875244 19.6733 0.875244 13C0.875244 6.33953 6.27072 0.931152 12.9441 0.931152Z",
    fill: "#FF2682"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.89177 7.47981H15.9834C17.355 7.47981 18.475 8.59985 18.475 9.97138V16.0287C18.475 17.4002 17.355 18.5203 15.9834 18.5203H9.89177C8.52034 18.5203 7.41172 17.4002 7.41172 16.0287V9.97138C7.41172 8.59985 8.52034 7.47981 9.89177 7.47981ZM12.9205 10.6114H12.9547C14.2691 10.6114 15.3549 11.6972 15.3549 13.0001C15.3549 14.3373 14.2691 15.4229 12.9547 15.4229H12.9205C11.6176 15.4229 10.5318 14.3373 10.5318 13.0001C10.5318 11.6972 11.6176 10.6114 12.9205 10.6114ZM12.9205 9.36563H12.9547C14.932 9.36563 16.5892 11.0228 16.5892 13.0001C16.5892 15.0115 14.932 16.6344 12.9547 16.6344H12.9205C10.9432 16.6344 9.32028 15.0115 9.32028 13.0001C9.32028 11.0228 10.9432 9.36563 12.9205 9.36563ZM16.5321 8.66845C16.9435 8.66845 17.2978 9.01129 17.2978 9.43414C17.2978 9.84558 16.9435 10.1999 16.5321 10.1999C16.0863 10.1999 15.7663 9.84558 15.7663 9.43414C15.7663 9.01129 16.0863 8.66845 16.5321 8.66845ZM9.86893 6.33693H16.0177C17.995 6.33693 19.6179 7.95985 19.6179 9.93702V16.063C19.6179 18.0402 17.995 19.6631 16.0177 19.6631H9.86893C7.89166 19.6631 6.25732 18.0402 6.25732 16.063V9.93702C6.25732 7.95985 7.89166 6.33693 9.86893 6.33693Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.7e1f94c4ad49cd4e7cc17a6565fe2110.svg";
export { ForwardRef as ReactComponent };